import React, { useEffect, useRef, useState } from "react";
import OgImg from "../assets/images/raster/components/common/mainscreen.png";
import { ANALYTICS_CATEGORY, PAGES } from "../helpers/constants";
import {
  KEYWORDS,
  BOTTOM_OPTIONS_FORM,
  CENTER_OPTIONS_FORM,
  BANNER_REDIRECT_URL,
} from "../components/es/index.content";
import useHash from "../hooks/useHash";
import Layout from "../layouts/LayoutDefault";
import Seo from "../components/Seo";
import HomeIntro from "../components/es/HomeIntro";
import ProAiBannerContainer from "../containers/common/ProAiBannerContainer";
import ProAiBanner from "../components/es/ProAiBanner";
import ChromeStoreRating from "../components/es/ChromeStoreRating";
import Brands from "../components/common/Brands";
import RatingOverview from "../components/es/RatingOverview";
import Testimonials from "../components/es/Testimonials";
import CustomizableContainer from "../containers/Paywalls/Customizable/CustomizableContainer";
import ProValue from "../components/es/ProValue";
import Partners from "../components/es/Partners";
import Confession from "../components/es/Confession";
import ProInstall from "../components/es/ProInstall";
import Support from "../components/es/Support";
import SuccessStories from "../components/es/SuccessStories";
import Guides from "../components/es/Guides";
import Idea from "../components/es/Idea";
import FormContainer from "../containers/common/forms/FormContainer";
import FormPage from "../components/es/FormPage";
import "../components/es/index.scss";

const LANGUAGE = "es";

const PgESMain = () => {
  const [isShowYoutubeModal, setIsShowYoutubeModal] = useState(false);
  const [urlYoutubeModal, setUrlYoutubeModal] = useState("");
  const pricingRef = useRef(null);
  const homeIntroRef = useRef(null);
  const closeYoutubeModal = () => setUrlYoutubeModal("");
  useHash("#partners");

  useEffect(() => {
    setIsShowYoutubeModal(!!urlYoutubeModal);
  }, [urlYoutubeModal]);

  return (
    <>
      <Seo
        title="AMZScout | Herramientas para Vender en Amazon"
        description="Utiliza AMZScout para facilitar la investigación de productos en Amazon con herramientas precisas. Encuentra nichos rentables y productos para vender con FBA. Comienza tu prueba gratuita"
        page="es"
        manifest="browserconfig-index.xml"
        ogImg={OgImg}
        keywords={KEYWORDS}
      />
      <Layout
        customClass="PgEM"
        isShowYoutubeModal={isShowYoutubeModal}
        tariffsElement={pricingRef}
        closeYoutubeModal={closeYoutubeModal}
        urlYoutubeModal={urlYoutubeModal}
        isShowLanguageSwitcher
        language={LANGUAGE}
      >
        <HomeIntro homeIntroRef={homeIntroRef} />
        <ProAiBannerContainer
          category={ANALYTICS_CATEGORY.ES}
          redirectUrl={BANNER_REDIRECT_URL}
        >
          <ProAiBanner />
        </ProAiBannerContainer>
        <ChromeStoreRating />
        <Brands />
        <RatingOverview />
        <CustomizableContainer
          pricingRef={pricingRef}
          customClass="PgEM-Pricing"
          language={LANGUAGE}
        />
        <Testimonials setUrlYoutubeModal={setUrlYoutubeModal} />
        <ProValue />
        <FormContainer page={PAGES.ES} language={LANGUAGE}>
          <FormPage option={CENTER_OPTIONS_FORM} />
        </FormContainer>
        <Partners />
        <Confession />
        <ProInstall />
        <Support />
        <SuccessStories />
        <Idea />
        <Guides />
        <FormContainer page={PAGES.ES} language={LANGUAGE}>
          <FormPage option={BOTTOM_OPTIONS_FORM} />
        </FormContainer>
        <ProAiBannerContainer
          category={ANALYTICS_CATEGORY.ES}
          redirectUrl={BANNER_REDIRECT_URL}
        >
          <ProAiBanner />
        </ProAiBannerContainer>
      </Layout>
    </>
  );
};
export default PgESMain;
